import { CustomVideoPlayer } from "@/components/ui/custom-video-player";

export function DesignPlatformVideo() {
  return (
    <div className="w-full h-full overflow-hidden">
      <CustomVideoPlayer
        imageUrl="https://res.cloudinary.com/dvoreldfc/image/upload/v1782581023/ChatGPT_Image_Jun_27_2026_10_50_57_PM_yodgke.png"
        className="w-full h-full [&>img]:w-full [&>img]:h-full"
      />
    </div>
  );
}